import httpService from "..";

const lapseRunsUrl = () =>
  `${process.env.REACT_APP_API_URL}/api/${process.env.REACT_APP_VERSION}/admin/lapse-runs`;

export type LapseRunStatus =
  | "PENDING"
  | "APPROVED"
  | "COMPLETED"
  | "REJECTED"
  | "FAILED";

export type LapseRunMemberStatus =
  | "INCLUDED"
  | "EXCLUDED"
  | "LAPSED"
  | "SKIPPED"
  | "FAILED";

export interface LapseRunGroup {
  id: number;
  GroupName: string;
  GroupLevel?: number;
}

export interface LapseRunMemberInfo {
  id: number;
  Cellphone?: string;
  Name?: string;
  Surname?: string;
  TotalPremium?: string;
  PolicyLapsed?: boolean;
}

export interface LapseRunMember {
  id: number;
  lapseRunId: number;
  memberId: number;
  status: LapseRunMemberStatus;
  memberGroupId: number;
  owningGroupId: number;
  outstandingPremium?: string | number | null;
  totalPremium?: string | number | null;
  policyNumber?: string | null;
  name?: string | null;
  surname?: string | null;
  excludedAt?: string | null;
  excludedBy?: string | number | null;
  excludeReason?: string | null;
  errorMessage?: string | null;
  MemberGroup?: LapseRunGroup | null;
  OwningGroup?: LapseRunGroup | null;
  Member?: LapseRunMemberInfo | null;
}

export interface LapseRun {
  id: number;
  status: LapseRunStatus;
  createdAt?: string | null;
  createdBy?: string | number | null;
  reviewedAt?: string | null;
  reviewedBy?: string | number | null;
  approvedAt?: string | null;
  approvedBy?: string | number | null;
  proposedCount?: number;
  includedCount?: number;
  excludedCount?: number;
  lapsedCount?: number;
  errorCount?: number;
  notes?: string | null;
  errorMessage?: string | null;
  cronJobLogId?: number | null;
  owningGroupId?: number | null;
  OwningGroup?: LapseRunGroup | null;
  members?: LapseRunMember[];
}

export interface GetLapseRunByIdParams {
  status?: LapseRunMemberStatus;
  owningGroupId?: number;
}

export interface ExcludeLapseRunMembersPayload {
  memberIds: number[];
  excludeReason?: string;
}

export interface IncludeLapseRunMembersPayload {
  memberIds: number[];
}

export interface RejectLapseRunPayload {
  notes?: string;
}

export const getLapseRunsApi = async (status?: LapseRunStatus) => {
  return await httpService(lapseRunsUrl(), "get", undefined, {
    ...(status ? { status } : {}),
  });
};

export const getLapseRunByIdApi = async (
  id: number | string,
  params: GetLapseRunByIdParams = {}
) => {
  return await httpService(`${lapseRunsUrl()}/${id}`, "get", undefined, {
    ...(params.status ? { status: params.status } : {}),
    ...(params.owningGroupId != null
      ? { owningGroupId: params.owningGroupId }
      : {}),
  });
};

export const excludeLapseRunMembersApi = async (
  id: number | string,
  data: ExcludeLapseRunMembersPayload
) => {
  return await httpService(`${lapseRunsUrl()}/${id}/members`, "delete", data);
};

export const includeLapseRunMembersApi = async (
  id: number | string,
  data: IncludeLapseRunMembersPayload
) => {
  return await httpService(`${lapseRunsUrl()}/${id}/members`, "post", data);
};

export const approveLapseRunApi = async (id: number | string) => {
  return await httpService(`${lapseRunsUrl()}/${id}/approve`, "post");
};

export const rejectLapseRunApi = async (
  id: number | string,
  data: RejectLapseRunPayload = {}
) => {
  return await httpService(`${lapseRunsUrl()}/${id}/reject`, "post", data);
};
